import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`In a federated architecture, each of your graph's `}<a parentName="p" {...{
        "href": "https://www.apollographql.com/docs/federation/subgraphs/"
      }}>{`subgraphs`}</a>{` uses the Rover CLI to register its schema with Apollo:`}</p>
    <div {...{
      "className": "mermaid",
      "data-processed": "true"
    }}><svg parentName="div" {...{
        "id": "mermaid-1623332974010",
        "width": "100%",
        "xmlns": "http://www.w3.org/2000/svg",
        "xmlnsXLink": "http://www.w3.org/1999/xlink",
        "height": "303",
        "style": {
          "maxWidth": "857.875px"
        },
        "viewBox": "0 0 857.875 303"
      }}><style parentName="svg">{`#mermaid-1623332974010{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;fill:#333;}#mermaid-1623332974010 .error-icon{fill:#552222;}#mermaid-1623332974010 .error-text{fill:#552222;stroke:#552222;}#mermaid-1623332974010 .edge-thickness-normal{stroke-width:2px;}#mermaid-1623332974010 .edge-thickness-thick{stroke-width:3.5px;}#mermaid-1623332974010 .edge-pattern-solid{stroke-dasharray:0;}#mermaid-1623332974010 .edge-pattern-dashed{stroke-dasharray:3;}#mermaid-1623332974010 .edge-pattern-dotted{stroke-dasharray:2;}#mermaid-1623332974010 .marker{fill:#333333;stroke:#333333;}#mermaid-1623332974010 .marker.cross{stroke:#333333;}#mermaid-1623332974010 svg{font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:16px;}#mermaid-1623332974010 .label{font-family:"trebuchet ms",verdana,arial,sans-serif;color:#333;}#mermaid-1623332974010 .cluster-label text{fill:#333;}#mermaid-1623332974010 .cluster-label span{color:#333;}#mermaid-1623332974010 .label text,#mermaid-1623332974010 span{fill:#333;color:#333;}#mermaid-1623332974010 .node rect,#mermaid-1623332974010 .node circle,#mermaid-1623332974010 .node ellipse,#mermaid-1623332974010 .node polygon,#mermaid-1623332974010 .node path{fill:#ECECFF;stroke:#9370DB;stroke-width:1px;}#mermaid-1623332974010 .node .label{text-align:center;}#mermaid-1623332974010 .node.clickable{cursor:pointer;}#mermaid-1623332974010 .arrowheadPath{fill:#333333;}#mermaid-1623332974010 .edgePath .path{stroke:#333333;stroke-width:1.5px;}#mermaid-1623332974010 .flowchart-link{stroke:#333333;fill:none;}#mermaid-1623332974010 .edgeLabel{background-color:#e8e8e8;text-align:center;}#mermaid-1623332974010 .edgeLabel rect{opacity:0.5;background-color:#e8e8e8;fill:#e8e8e8;}#mermaid-1623332974010 .cluster rect{fill:#ffffde;stroke:#aaaa33;stroke-width:1px;}#mermaid-1623332974010 .cluster text{fill:#333;}#mermaid-1623332974010 .cluster span{color:#333;}#mermaid-1623332974010 div.mermaidTooltip{position:absolute;text-align:center;max-width:200px;padding:2px;font-family:"trebuchet ms",verdana,arial,sans-serif;font-size:12px;background:hsl(80,100%,96.2745098039%);border:1px solid #aaaa33;border-radius:2px;pointer-events:none;z-index:100;}#mermaid-1623332974010 .node rect,#mermaid-1623332974010 .node circle,#mermaid-1623332974010 .node polygon,#mermaid-1623332974010 .node path{stroke-width:2px;stroke:#3f20ba;fill:#F4F6F8;}#mermaid-1623332974010 .node.secondary rect,#mermaid-1623332974010 .node.secondary circle,#mermaid-1623332974010 .node.secondary polygon,#mermaid-1623332974010 .node.tertiary rect,#mermaid-1623332974010 .node.tertiary circle,#mermaid-1623332974010 .node.tertiary polygon{fill:white;}#mermaid-1623332974010 .node.secondary rect,#mermaid-1623332974010 .node.secondary circle,#mermaid-1623332974010 .node.secondary polygon{stroke:#f25cc1;}#mermaid-1623332974010 .cluster rect,#mermaid-1623332974010 .node.tertiary rect,#mermaid-1623332974010 .node.tertiary circle,#mermaid-1623332974010 .node.tertiary polygon{stroke:#41d9d3;}#mermaid-1623332974010 .cluster rect{fill:none;stroke-width:2px;}#mermaid-1623332974010 .label,#mermaid-1623332974010 .edgeLabel{background-color:white;line-height:1.3;}#mermaid-1623332974010 .edgeLabel rect{background:none;fill:none;}#mermaid-1623332974010 .messageText,#mermaid-1623332974010 .noteText,#mermaid-1623332974010 .loopText{font-size:12px;stroke:none;}#mermaid-1623332974010 g rect,#mermaid-1623332974010 polygon.labelBox{stroke-width:2px;}#mermaid-1623332974010 g rect.actor{stroke:#26a29d;fill:white;}#mermaid-1623332974010 g rect.note{stroke:#f25cc1;fill:white;}#mermaid-1623332974010 g line.loopLine,#mermaid-1623332974010 polygon.labelBox{stroke:#3f20ba;fill:white;}#mermaid-1623332974010:root{--mermaid-font-family:"trebuchet ms",verdana,arial,sans-serif;}#mermaid-1623332974010 flowchart{fill:apa;}`}</style><g parentName="svg"><g parentName="g" {...{
            "className": "output"
          }}><g parentName="g" {...{
              "className": "clusters"
            }}><g parentName="g" {...{
                "className": "cluster",
                "id": "flowchart-subGraph0-26",
                "transform": "translate(196.7109375,151.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "width": "377.421875",
                  "height": "287",
                  "x": "-188.7109375",
                  "y": "-143.5"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0, -129.5)",
                  "id": "mermaid-1623332974010Text"
                }}><g parentName="g" {...{
                    "transform": "translate(0,0)"
                  }}><foreignObject parentName="g" {...{
                      "width": "0",
                      "height": "0"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}></div></foreignObject></g></g></g></g><g parentName="g" {...{
              "className": "edgePaths"
            }}><g parentName="g" {...{
                "className": "edgePath LS-gateway LE-subgraphA",
                "id": "L-gateway-subgraphA",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M99.69926264044943,132L158.4375,62.5L187.109375,62.5",
                  "markerEnd": "url(#arrowhead38)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead38",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-gateway LE-subgraphB",
                "id": "L-gateway-subgraphB",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M133.4375,151.5L158.4375,151.5L188.9375,151.5",
                  "markerEnd": "url(#arrowhead39)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead39",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-gateway LE-subgraphC",
                "id": "L-gateway-subgraphC",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M99.69926264044943,171L158.4375,240.5L183.4375,240.5",
                  "markerEnd": "url(#arrowhead40)",
                  "style": {
                    "fill": "none"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead40",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 0 0 L 0 0 z",
                      "style": {
                        "fill": "#333"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-subgraphA LE-registry",
                "id": "L-subgraphA-registry",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M356.75,62.5L385.421875,62.5L503.109375,62.5L684.9548367275281,132.5",
                  "markerEnd": "url(#arrowhead41)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead41",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-subgraphB LE-registry",
                "id": "L-subgraphB-registry",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M354.921875,151.5L385.421875,151.5L503.109375,151.5L621.296875,152",
                  "markerEnd": "url(#arrowhead42)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead42",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g><g parentName="g" {...{
                "className": "edgePath LS-subgraphC LE-registry",
                "id": "L-subgraphC-registry",
                "style": {
                  "opacity": "1"
                }
              }}><path parentName="g" {...{
                  "className": "path",
                  "d": "M360.421875,240.5L385.421875,240.5L503.109375,240.5L684.9548367275281,171.5",
                  "markerEnd": "url(#arrowhead43)",
                  "style": {
                    "fill": "none",
                    "strokeWidth": "2px",
                    "strokeDasharray": "3"
                  }
                }}></path><defs parentName="g"><marker parentName="defs" {...{
                    "id": "arrowhead43",
                    "viewBox": "0 0 10 10",
                    "refX": "9",
                    "refY": "5",
                    "markerUnits": "strokeWidth",
                    "markerWidth": "8",
                    "markerHeight": "6",
                    "orient": "auto"
                  }}><path parentName="marker" {...{
                      "d": "M 0 0 L 10 5 L 0 10 z",
                      "className": "arrowheadPath",
                      "style": {
                        "strokeWidth": "1",
                        "strokeDasharray": "1, 0"
                      }
                    }}></path></marker></defs></g></g><g parentName="g" {...{
              "className": "edgeLabels"
            }}><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-gateway-subgraphA",
                        "className": "edgeLabel L-LS-gateway' L-LE-subgraphA"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-gateway-subgraphB",
                        "className": "edgeLabel L-LS-gateway' L-LE-subgraphB"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(0,0)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "0",
                    "height": "0"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "0",
                    "height": "0"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-gateway-subgraphC",
                        "className": "edgeLabel L-LS-gateway' L-LE-subgraphC"
                      }}></span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "translate(503.109375,62.5)",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(-92.6875,-10)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "185.375",
                    "height": "20"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "185.375",
                    "height": "20"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-subgraphA-registry",
                        "className": "edgeLabel L-LS-subgraphA' L-LE-registry"
                      }}>{`rover subgraph publish`}</span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "translate(503.109375,151.5)",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(-92.6875,-10)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "185.375",
                    "height": "20"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "185.375",
                    "height": "20"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-subgraphB-registry",
                        "className": "edgeLabel L-LS-subgraphB' L-LE-registry"
                      }}>{`rover subgraph publish`}</span></div></foreignObject></g></g><g parentName="g" {...{
                "className": "edgeLabel",
                "transform": "translate(503.109375,240.5)",
                "style": {
                  "opacity": "1"
                }
              }}><g parentName="g" {...{
                  "transform": "translate(-92.6875,-10)",
                  "className": "label"
                }}><rect parentName="g" {...{
                    "rx": "0",
                    "ry": "0",
                    "width": "185.375",
                    "height": "20"
                  }}></rect><foreignObject parentName="g" {...{
                    "width": "185.375",
                    "height": "20"
                  }}><div parentName="foreignObject" {...{
                      "xmlns": "http://www.w3.org/1999/xhtml",
                      "style": {
                        "display": "inline-block",
                        "whiteSpace": "nowrap"
                      }
                    }}><span parentName="div" {...{
                        "id": "L-L-subgraphC-registry",
                        "className": "edgeLabel L-LS-subgraphC' L-LE-registry"
                      }}>{`rover subgraph publish`}</span></div></foreignObject></g></g></g><g parentName="g" {...{
              "className": "nodes"
            }}><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-gateway-13",
                "transform": "translate(83.21875,151.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "19.5",
                  "ry": "19.5",
                  "x": "-50.21875",
                  "y": "-19.5",
                  "width": "100.4375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-35.34375,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "70.6875",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Gateway`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-subgraphA-14",
                "transform": "translate(271.9296875,62.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-84.8203125",
                  "y": "-19.5",
                  "width": "169.640625",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-74.8203125,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "149.640625",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Products subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-subgraphB-15",
                "transform": "translate(271.9296875,151.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-82.9921875",
                  "y": "-19.5",
                  "width": "165.984375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-72.9921875,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "145.984375",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Reviews subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node default",
                "id": "flowchart-subgraphC-16",
                "transform": "translate(271.9296875,240.5)",
                "style": {
                  "opacity": "1"
                }
              }}><rect parentName="g" {...{
                  "rx": "0",
                  "ry": "0",
                  "x": "-88.4921875",
                  "y": "-19.5",
                  "width": "176.984375",
                  "height": "39",
                  "className": "label-container"
                }}></rect><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-78.4921875,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "156.984375",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Inventory subgraph`}</div></foreignObject></g></g></g><g parentName="g" {...{
                "className": "node secondary",
                "id": "flowchart-registry-17",
                "transform": "translate(735.3359375,151.5)",
                "style": {
                  "opacity": "1"
                }
              }}><polygon parentName="g" {...{
                  "points": "9.75,0 219.328125,0 229.078125,-19.5 219.328125,-39 9.75,-39 0,-19.5",
                  "transform": "translate(-114.5390625,19.5)",
                  "className": "label-container"
                }}></polygon><g parentName="g" {...{
                  "className": "label",
                  "transform": "translate(0,0)"
                }}><g parentName="g" {...{
                    "transform": "translate(-94.7890625,-9.5)"
                  }}><foreignObject parentName="g" {...{
                      "width": "189.578125",
                      "height": "19"
                    }}><div parentName="foreignObject" {...{
                        "xmlns": "http://www.w3.org/1999/xhtml",
                        "style": {
                          "display": "inline-block",
                          "whiteSpace": "nowrap"
                        }
                      }}>{`Apollo Schema Registry`}</div></foreignObject></g></g></g></g></g></g></svg></div>
    <p>{`If you haven't yet:`}</p>
    <ul>
      <li parentName="ul">
        <a href="https://www.apollographql.com/docs/rover/getting-started/" target="_blank">Install the Rover CLI.</a>
      </li>
      <li parentName="ul">
        <a href="https://www.apollographql.com/docs/rover/configuring/" target="_blank">Authenticate Rover</a> with Apollo Studio.
      </li>
    </ul>
    <p>{`Then, `}<strong parentName="p">{`do the following for each of your subgraphs`}</strong>{`:`}</p>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`Obtain the following values, which are required for the `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`rover subgraph publish`}</code>{` command:`}</p>
        <ul parentName="li">
          <li parentName="ul">{`The name that uniquely identifies the subgraph within your graph (e.g., `}<code parentName="li" {...{
              "className": "language-text"
            }}>{`products`}</code>{`).`}</li>
          <li parentName="ul">{`The URL that your gateway will use to communicate with the subgraph (e.g., `}<code parentName="li" {...{
              "className": "language-text"
            }}>{`http://products-graphql.svc.cluster.local:4001/`}</code>{`).`}</li>
        </ul>
      </li>
      <li parentName="ol">
        <p parentName="li">{`Run the `}<code parentName="p" {...{
            "className": "language-text"
          }}>{`rover subgraph publish`}</code>{` command, providing it your subgraph's schema in one of the ways shown:`}</p>
        <div parentName="li" {...{
          "className": "gatsby-highlight",
          "data-language": "bash"
        }}><pre parentName="div" {...{
            "style": {
              "counterReset": "linenumber NaN"
            },
            "className": "language-bash line-numbers"
          }}><code parentName="pre" {...{
              "className": "language-bash"
            }}><span parentName="code" {...{
                "className": "token comment"
              }}>{`# Provide a local .graphql file path`}</span>{`
rover subgraph publish my-graph@my-variant --name products --routing-url http://products-graphql.svc.cluster.local:4001/ --schema ./schema.graphql 

`}<span parentName="code" {...{
                "className": "token comment"
              }}>{`# Provide an introspection result via stdin`}</span>{`
rover subgraph introspect http://localhost:4000 `}<span parentName="code" {...{
                "className": "token operator"
              }}>{`|`}</span>{` rover subgraph publish my-graph@my-variant --name products --routing-url http://products-graphql.svc.cluster.local:4001/ --schema -`}</code><span parentName="pre" {...{
              "aria-hidden": "true",
              "className": "line-numbers-rows",
              "style": {
                "whiteSpace": "normal",
                "width": "auto",
                "left": "0"
              }
            }}><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span><span parentName="span"></span></span></pre></div>
      </li>
    </ol>
    <p>{`As you register your subgraph schemas, the schema registry attempts to `}<strong parentName="p">{`compose`}</strong>{` their latest versions into a single `}<strong parentName="p">{`supergraph schema`}</strong>{`. Whenever composition succeeds, your gateway can fetch the latest supergraph schema from the registry.`}</p>
    <p>{`You can also manually fetch your latest supergraph schema with the `}<code parentName="p" {...{
        "className": "language-text"
      }}>{`rover supergraph fetch`}</code>{` command, or retrieve it from your graph's `}<strong parentName="p">{`Schema > SDL`}</strong>{` tab in Apollo Studio.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      